<template>
  <v-dialog
    v-model="showDeleteJobDialog"
    max-width="40%"
    hide-overlay
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-card>
      <v-card-title class="primary white--text">
        <h3 class="headline mb-0">{{ $t('texts.deleteJob') }}</h3>
        <v-spacer/>
        <v-btn text small fab @click="showDeleteJobDialog = false">
          <v-icon color="white">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <p>{{ $t('texts.deleteJobQuestion') }}</p>
        <p></p>
        <ul>
          <li>
            {{ jobTitle }}
          </li>
        </ul>
      </v-card-text>
      <v-card-text v-if="isObligationRequirement">
        <form>
          <v-radio-group
            v-model="cancellationReasonCode"
            hide-details
          >
            <v-radio
              label="Stelle konnte selber oder anderweitig besetzt werden"
              value="OCCUPIED_OTHER"
              color="primary"
            />
            <v-radio
              label="Stelle konnte nicht besetzt werden"
              value="NOT_OCCUPIED"
              color="primary"
            />
            <v-radio
              label="Stelle wird geändert oder neu ausgeschrieben"
              value="CHANGE_OR_REPOSE"
              color="primary"
            />
          </v-radio-group>
        </form>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          color="red darken-2"
          class="white--text"
          @click.stop.prevent="submitDeleteForm()"
          :disabled="deleteJobPending"
          :loading="deleteJobPending"
        >
          {{ $t('texts.deleteDefinitely') }}
          <v-icon right class="white--text">delete</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState: mapCompanyJobsState, mapActions: mapCompanyJobsActions } = createNamespacedHelpers('company/jobs');

export default {
  name: 'DeleteJobDialog',
  data() {
    return {
      showDeleteJobDialog: false,
      jobTitle: '',
      jobId: null,
      cancellationReasonCode: null,
      isObligationRequirement: false,
      listType: 'active',
    };
  },
  mounted() {
    this.$eventBus.$on('show-delete-job-dialog', (args) => {
      this.jobTitle = args.title;
      this.jobId = args.id;
      this.isObligationRequirement = args.isObligationRequirement;
      this.listType = args.listType;
      this.showDeleteJobDialog = true;
    });
  },
  computed: {
    ...mapCompanyJobsState([
      'deleteJobPending',
    ]),
    selectedCompanyId() {
      return this.$route.params.companyId;
    },
  },
  methods: {
    ...mapCompanyJobsActions([
      'deleteJob',
    ]),
    submitDeleteForm() {
      const payload = {
        companyId: this.selectedCompanyId,
        jobId: this.jobId,
        cancellationReasonCode: this.cancellationReasonCode,
        listType: this.listType,
      };
      this.deleteJob(payload).then(() => {
        this.showDeleteJobDialog = false;
      });
    },
  },
};
</script>
